export default __webpack_public_path__ + "static/media/mob-prp.a6317068.svg";